// extracted by mini-css-extract-plugin
export var buttonContent = "_2w-0";
export var centered = "_2w-1";
export var centeredFlex = "_2w-2";
export var errorText = "_2w-3";
export var icon = "_2w-4";
export var iconButtonContent = "_2w-5";
export var monospace = "_2w-6";
export var padded = "_2w-7";